/**
 * Review constants - aligned with mobile (packages/mobile/constants/reviewConstants.ts)
 */

export const REVIEW_COLORS = {
  positive: '#4CAF50',
  negative: '#EF5350',
} as const;

export const TAG_LIMITS = {
  PREDEFINED_MAX: 3,
  CUSTOM_MAX: 2,
} as const;

export const TAG_EMOJIS: Record<string, string> = {
  // === Positive tags (backend real) ===
  'Buenos pases': '🅿️',
  'Goleador': '⚽',
  'Defensa duro': '🛡️',
  'No se cansa': '🏃',
  'Buena vision': '👁️',
  'Powershot': '💥',
  'Buena gambeta': '🔥',
  'Centro perfecto': '🎯',
  'Arquerazo': '🧤',
  'Mediocampista de area': '🧠',
  'Velocista': '⚡',
  'Lider': '👑',
  'Intercepta todo': '🚧',
  'Asistidor': '🎁',
  // === Negative tags (backend real) ===
  'Morfon': '🍔',
  'Anticristo del futbol': '😈',
  'Muertiñho': '💀',
  'Anciano': '🧓',
  'No marca': '🫥',
  'No ataja': '🧈',
  'No la pasa': '🤳',
  'Deberia volver a la escuelita de futbol': '🏫',
  'No corre': '🐌',
  'Le pega afuera': '🚀',
  'Se pierde en la cancha': '🧭',
  'No entiende el futbol': '🤷',
  'Juega para el otro equipo': '🔄',
  'No para una bocha': '🧱',
  'No trae efectivo': '💸',
  'Se lesiona solo': '🤕',
  // === Legacy tags (backward-compatibility) ===
  'Buen compañero': '🤝',
  'Técnica': '⚽',
  'Velocidad': '⚡',
  'Precisión': '🎯',
  'Liderazgo': '👑',
  'Visión de juego': '👁️',
  'Pases': '🅿️',
  'Defensa': '🛡️',
  'Goles': '⚽',
  'Egoísta': '🤳',
  'Lento': '🐌',
  'Falta de comunicación': '🔇',
  'Poca precisión': '❌',
  'Agresivo': '😡',
  'Morfón': '🍔',
  'Llega tarde': '⏰',
  'Se queja': '😫',
};
